module.exports = function routerEvents() {
  const Router = require('next/router').default;
  const picturefill = require('picturefill');

  if (document.documentMode) {
    setInterval(() => picturefill(), 1000);
  } else {
    picturefill();
  }
  function onRouteUpdate() {
    let count = 0;
    if (typeof window !== 'undefined' && window.load_universal) {
      const pgDataLayerCheckInterval = setInterval(() => {
        if (
          window.dataLayer !== undefined &&
          window.PGdataLayer !== undefined &&
          window.PGdataLayer.updated
        ) {
          window.PGdataLayer.updated = false;
          window.dataLayer.push({ event: 'virtualPageview' });
          clearInterval(pgDataLayerCheckInterval);
        }
        count += 1;
        if (count === 50) {
          clearInterval(pgDataLayerCheckInterval);
        }
      }, 150);
    }

    window.scrollTo(0, 0); // When moving to another page it will always go top
    // Adchoices plugin

  }

  function onRouteChangeStart() {}

  Router.events.on('routeChangeStart', onRouteChangeStart);
  Router.events.on('routeChangeComplete', onRouteUpdate);
};
